module.exports = __webpack_public_path__ + "static/media/Sort.8892d866.svg";